if (!customElements.get('marina-purchase-consent')) {
  customElements.define(
    'marina-purchase-consent',
    class MarinaPurchaseConsent extends HTMLElement {
      connectedCallback() {
        this.serviceDialog = this.querySelector('[data-service-dialog]');
        this.confirmDialog = this.querySelector('[data-confirm-dialog]');
        this.policyConsent = this.querySelector('[data-policy-consent]');
        this.actionButtons = [...this.querySelectorAll('[data-consent-destination]')];
        this.error = this.querySelector('[data-consent-error]');
        this.lastFocusedElement = null;

        this.querySelector('[data-open-service-modal]')?.addEventListener('click', () => {
          this.openDialog(this.serviceDialog);
        });

        this.querySelectorAll('[data-dialog-close]').forEach((button) => {
          button.addEventListener('click', () => this.closeOpenDialog());
        });

        [this.serviceDialog, this.confirmDialog].forEach((dialog) => {
          dialog?.addEventListener('click', (event) => {
            if (event.target === dialog) this.closeDialog(dialog);
          });
          dialog?.addEventListener('close', () => this.unlockPage());
        });

        this.policyConsent?.addEventListener('change', () => this.updateConsentState());

        this.actionButtons.forEach((button) => {
          button.addEventListener('click', () => this.saveConsentAndContinue(button));
        });

        this.closest('product-info')
          ?.querySelectorAll('.shopify-payment-button')
          .forEach((button) => button.setAttribute('hidden', ''));

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event?.source !== 'product-form' || !this.matchesCurrentVariant(event.productVariantId)) return;
            window.setTimeout(() => this.openConfirmation(), 80);
          });
        }
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
      }

      matchesCurrentVariant(variantId) {
        const activeVariant = this.closest('product-info')?.querySelector('product-form input[name="id"]')?.value;
        return !activeVariant || String(activeVariant) === String(variantId);
      }

      openConfirmation() {
        document.querySelector('cart-notification')?.close?.();
        document.querySelector('cart-drawer')?.close?.();
        this.policyConsent.checked = false;
        this.error.hidden = true;
        this.updateConsentState();
        this.openDialog(this.confirmDialog);
      }

      openDialog(dialog) {
        if (!dialog || dialog.open) return;
        this.lastFocusedElement = document.activeElement;
        document.body.classList.add('mv-consent-open');
        dialog.showModal();
        dialog.querySelector('[data-dialog-close]')?.focus();
      }

      closeDialog(dialog) {
        if (!dialog?.open) return;
        dialog.close();
        this.lastFocusedElement?.focus?.();
      }

      closeOpenDialog() {
        const dialog = [this.serviceDialog, this.confirmDialog].find((item) => item?.open);
        this.closeDialog(dialog);
      }

      unlockPage() {
        if (!this.querySelector('dialog[open]')) document.body.classList.remove('mv-consent-open');
      }

      updateConsentState() {
        const accepted = Boolean(this.policyConsent?.checked);
        this.actionButtons.forEach((button) => {
          button.disabled = !accepted;
        });
        if (accepted) this.error.hidden = true;
      }

      async saveConsentAndContinue(button) {
        if (!this.policyConsent.checked) {
          this.error.hidden = false;
          this.error.focus?.();
          return;
        }

        this.actionButtons.forEach((item) => (item.disabled = true));
        const acceptedAt = new Date().toISOString();

        try {
          const response = await fetch(window.routes.cart_update_url, {
            ...fetchConfig('json'),
            body: JSON.stringify({
              attributes: {
                'Consenso termini e privacy': `Accettato — ${acceptedAt}`,
                'Conferma maggiore età': `Sì — ${acceptedAt}`,
              },
            }),
          });

          if (!response.ok) throw new Error('Consent update failed');
          window.location.assign(button.dataset.consentDestination);
        } catch (error) {
          this.error.textContent = 'Non è stato possibile salvare la conferma. Riprova.';
          this.error.hidden = false;
          this.updateConsentState();
        }
      }
    }
  );
}

function updateMarinaCartConsent(container) {
  if (!container) return;
  const policy = container.querySelector('[data-cart-policy-consent]');
  const scope = container.closest('.cart__blocks, .drawer__inner, cart-notification') || document;
  const checkoutButtons = scope.querySelectorAll('[data-consent-checkout], button[name="checkout"]');
  const accepted = Boolean(policy?.checked);

  checkoutButtons.forEach((button) => {
    button.disabled = !accepted;
    button.setAttribute('aria-disabled', String(!accepted));
  });

  if (accepted) container.querySelector('[data-cart-consent-error]')?.setAttribute('hidden', '');
}

function initializeMarinaCartConsent(root = document) {
  root.querySelectorAll?.('[data-cart-consent]').forEach((container) => updateMarinaCartConsent(container));
}

document.addEventListener('change', (event) => {
  const container = event.target.closest?.('[data-cart-consent]');
  if (container) updateMarinaCartConsent(container);
});

document.addEventListener(
  'click',
  (event) => {
    const checkoutButton = event.target.closest?.('[data-consent-checkout], button[name="checkout"]');
    if (!checkoutButton) return;
    const scope = checkoutButton.closest('.cart__blocks, .drawer__inner, cart-notification') || document;
    const container = scope.querySelector('[data-cart-consent]');
    if (!container) return;

    const accepted = container.querySelector('[data-cart-policy-consent]')?.checked;
    if (accepted) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const error = container.querySelector('[data-cart-consent-error]');
    error.hidden = false;
    error.setAttribute('tabindex', '-1');
    error.focus();
  },
  true
);

document.addEventListener('DOMContentLoaded', () => initializeMarinaCartConsent());

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    window.setTimeout(() => initializeMarinaCartConsent(), 120);
  });
}
